// ─────────────────────────────────────────────────────────────────────────────
// V2Routes — small v2 stand-ins for leftover v1 routes, so v2 never shows a v1 screen:
//   /dashboard/invoice/:id            → Invoices, with that invoice open in V2InvoiceView (Back returns to where you came from)
//   /dashboard/products/:id/(edit|adjust|history) → Stock, with that product's sheet open on the matching tab
//   /dashboard/accounts (empty v1 placeholder)    → Dashboard
//   V2Loading                          → the boot screen shown while OnboardingGate checks the account
// ─────────────────────────────────────────────────────────────────────────────
import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAppearance } from "./appearance";
import V2Shell from "./V2Shell";

// Super admin console pages render inside the v2 shell's admin variant (same logout as Dashboard.js).
export const adminFramed = (Page) => function AdminFramed(props) {
  const navigate = useNavigate();
  const logout = () => {
    localStorage.removeItem("token");
    props.showAlert?.("Logged out successfully", "success");
    navigate("/login");
  };
  return <V2Shell variant="admin" onLogout={logout}><Page {...props} /></V2Shell>;
};

export function V2InvoiceRedirect() {
  const { id } = useParams();
  return <Navigate to="/dashboard/viewinvoices" replace state={{ openInvoiceId: id, back: true }} />;
}

export const v2ProductRedirect = (tab) => function V2ProductRedirect() {
  const { id } = useParams();
  return <Navigate to="/dashboard/managestock" replace state={{ openProduct: { id, tab } }} />;
};

export function V2HomeRedirect() {
  return <Navigate to="/dashboard/home" replace />;
}

export function V2Loading() {
  useAppearance(); // backdrop, accent and font match the user's v2 appearance
  return (
    <div className="v2 v2-boot" role="status" aria-live="polite">
      <div className="v2-backdrop" aria-hidden="true" />
      <div className="v2-boot-card">
        <span className="v2-boot-mark" aria-hidden="true">e</span>
        <span className="v2-boot-bar" aria-hidden="true"><i /></span>
        <span className="v2-sr">Loading EazyBilling…</span>
      </div>
    </div>
  );
}
